export default {
  placeholder: {
    subject: '메시지 제목(LMS·MMS용, 최대 30자)',
    smsContent: '45자 초과시 LMS로 전환됩니다.',
    lmsContent: 'LMS 메시지는 1000자 까지 입력 가능합니다.',
    mmsContent: 'MMS 메시지는 1000자 까지 입력 가능합니다.',
    smsLength: '45자',
    lmsLength: '1000자',
    mmsLength: '1000자',
  },
  comment: {
    image: '※ MMS발송으로 전환됩니다.',
  },
};
